"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddExtraButtons = void 0;
const React = require("react");
const react_1 = require("react");
const Block_1 = require("../../../../../../components/base/structure/Block");
const ExtraSelectionButton_1 = require("../ExtraSelectionButton");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "AddExtraButtons");
/**
 * Quick add ingredients buttons
 */
const AddExtraButtons = ({ salesOrderItemBuilt, categoryBlueprintStockedProducts, category, addProduct, removeProducts }) => {
    const { productBlueprint } = salesOrderItemBuilt;
    const { name, hasAddButtons, extrasLabel } = category;
    const hasCategoryRestrictionRule = (0, react_1.useMemo)(() => productBlueprint.hasCategoryRestrictionRule(name), [name]);
    // if these products are part of a category selection we always want to show the first one at the top so its obvious to the customer
    if (hasCategoryRestrictionRule) {
        categoryBlueprintStockedProducts = salesOrderItemBuilt.getCategoryProductsSortedByLastSelection(name);
    }
    // if no extra selections are allowed in this category there's no point in added the buttons
    const noExtraSelectionsAllowed = (0, react_1.useMemo)(() => productBlueprint.noExtraSelectionsAllowedInCategory(name), [name]);
    if (noExtraSelectionsAllowed) {
        return null;
    }
    // control whether to show quick add buttons based on the category definition.
    // this will work for category selection or single selections
    if (!hasAddButtons) {
        return null;
    }
    // text to show based on product category selection whether its for first
    // choice in a category or just a normal extra selection
    const sectionHeader = extrasLabel ? extrasLabel : "Add a bit more?";
    return (React.createElement(React.Fragment, null,
        React.createElement(Block_1.BlockTitle, { className: css("header") }, sectionHeader),
        categoryBlueprintStockedProducts.map((blueprintStockedProduct) => (React.createElement(ExtraSelectionButton_1.ExtraSelectionButton, { key: `add-extra-button-${blueprintStockedProduct.productId}`, salesOrderItemBuilt: salesOrderItemBuilt, blueprintStockedProduct: blueprintStockedProduct, addProduct: addProduct, removeProducts: removeProducts })))));
};
exports.AddExtraButtons = AddExtraButtons;
//# sourceMappingURL=index.js.map